import { router } from 'expo-router';
import { Platform } from 'react-native';

import { useAppStore } from '@/src/state/app-store';

export function openUserProfile({
  currentUid,
  targetUid,
}: {
  currentUid?: string | null;
  targetUid?: string | null;
}) {
  if (!targetUid) {
    return;
  }

  if (currentUid && currentUid === targetUid) {
    router.push('/profile');
    return;
  }

  if (Platform.OS === 'web') {
    useAppStore.getState().setProfileNavigationTargetUid(targetUid);
    requestAnimationFrame(() => {
      setTimeout(() => router.push(`/users/${targetUid}`), 0);
    });
    return;
  }

  router.push(`/users/${targetUid}`);
}
